import React, { createContext, useContext, useState } from 'react'

const RegistrationContext = createContext({
  registrationData: null,
  updateRegistrationData: () => {},
  clearRegistrationData: () => {},
})

export const RegistrationProvider = ({ children }) => {
  const [registrationData, setRegistrationData] = useState(null)

  const updateRegistrationData = (data) => {
    setRegistrationData((prevData) => ({
      ...prevData, // Preserve existing data
      ...data, // Merge new data
    }))
  }

  const clearRegistrationData = () => {
    setRegistrationData(null)
  }
  console.log(registrationData, 'registrationData')
  return (
    <RegistrationContext.Provider
      value={{
        registrationData,
        updateRegistrationData,
        clearRegistrationData,
      }}
    >
      {children}
    </RegistrationContext.Provider>
  )
}

export const useRegistration = () => {
  const context = useContext(RegistrationContext)
  if (context === undefined) {
    throw new Error(
      'useRegistration must be used within a RegistrationProvider'
    )
  }
  return context
}
